import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell, faCog, faList, faExclamationTriangle, faHistory } from '@fortawesome/free-solid-svg-icons'
import { AlertsList } from '../components/alerts/AlertsList'
import { AlertSettings } from '../components/alerts/AlertSettings'
import { SensorThresholds } from '../components/alerts/SensorThresholds'
import { AlertControls } from '../components/alerts/AlertControls'
import { AlertHistoryTab } from '../components/alerts/AlertHistoryTab'

type AlertTab = 'active' | 'settings' | 'thresholds' | 'controls' | 'history'

export default function AlertsPage() {
  const [activeTab, setActiveTab] = useState<AlertTab>('active')

  const tabs = [
    {
      id: 'active' as const,
      label: 'Active Alerts',
      icon: faBell,
      component: AlertsList,
    },
    {
      id: 'settings' as const,
      label: 'Alert Settings',
      icon: faCog,
      component: AlertSettings,
    },
    {
      id: 'thresholds' as const,
      label: 'Sensor Thresholds',
      icon: faExclamationTriangle,
      component: SensorThresholds,
    },
    {
      id: 'controls' as const,
      label: 'Alert Controls',
      icon: faList,
      component: AlertControls,
    },
    {
      id: 'history' as const,
      label: 'Alert History',
      icon: faHistory,
      component: AlertHistoryTab,
    },
  ]

  const ActiveComponent = tabs.find((tab) => tab.id === activeTab)?.component || AlertsList

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Alert Management</h1>
        <p className="mt-1 text-sm text-gray-600">
          Configure alerts, thresholds, and notification settings for your IoT devices
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                flex items-center py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap
                ${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
            >
              <FontAwesomeIcon icon={tab.icon} className="mr-2 h-4 w-4" />
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="bg-white rounded-lg shadow">
        <ActiveComponent />
      </div>
    </div>
  )
}
